


















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Password from "vue-password-strength-meter";
import LifeCycle from "@/app/core/decorator/LifeCycle";

@Component({
  components: { Password }
})
export default class InputPasswordComponent extends Vue {
  @Prop({ type: String, required: true })
  public value!: string;

  @Prop({ type: String, required: true })
  public compKey!: string;

  @Prop({ type: Boolean, required: true })
  public setting!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  public disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  public isPending!: boolean;

  private isMounted: boolean = false;

  @LifeCycle
  private mounted() {
    this.isMounted = true;
  }

  public input(password: string) {
    this.$emit("input", password);
  }

  public get localValue(): string {
    return this.value;
  }

  public set localValue(password: string) {
    this.input(password);
  }

  private get elm(): HTMLElement {
    return this.$refs.component as HTMLElement;
  }

  public focus() {
    this.elm.focus();
  }

  @Watch("isMounted")
  @Watch("setting")
  private onChangeIsSetting() {
    this.elm.style.setProperty("--height", this.setting ? "2.5em" : "2em");
  }
}
